import * as d3 from 'd3';
import _ from 'lodash';
import p5 from 'p5';
import chroma from 'chroma-js';
import Utils from './utils';
const {RotateVector, RGBtoCMYK, CMYKtoRGB} = Utils;

const duration = 750;
const purple = '#2c2040';
const pink = '#bf6078';
const yellow = '#fad67d';
const colors = chroma.scale([purple, pink, yellow, pink, purple]).mode('hsl');
const colorScale = d3.scaleLinear().domain([0, 7, 12, 19, 23]).range([0, 0.25, 0.5, 0.75, 0.96]);

function drawFlower(svg, ctx, tl, data) {
  let petalsData = _.times(data.numPetals, (i) => {
    // const petalPath = i % 2 ? Utils.petalPath1 : Utils.petalPath2;
    let path;
    let rotate;
    if (data.sentiment > 0) {
      path = Utils.petalPath1(data.size);
      rotate = p5.prototype.randomGaussian(i * (360 / data.numPetals) + data.initialAngle, 2);
      return {path, pathStroke: Utils.petalInnerPath(path, 0.9, 2.5), rotate};
    } else {
      path = Utils.leafPath(data.size, true);
      // rotate = data.initialAngle;
      // rotate = p5.prototype.randomGaussian(data.initialAngle, 15);
      rotate = _.random(data.initialAngle - 60, data.initialAngle);

      if (data.sentiment < 0) {
        // if it's negative sentiment, only show stroke
        path = Utils.petalInnerPath(path, 0.8, 4);
      }
      return {path, rotate};
    }
  });
  const {branch, flower} = drawSVGPetals(svg, ctx, data, petalsData);
  animatePetals(branch, flower, ctx, data, petalsData);
}

function drawSVGPetals(svg, ctx, data, petalsData) {
  let {cx, cy} = data;
  // cx = p5.prototype.randomGaussian(cx, 1);
  // cy = p5.prototype.randomGaussian(cy, 1);
  // const color = colors(colorScale(data.date.getHours()));
  const color = `rgb(${data.color})`;

  // flower branch
  const mx = p5.prototype.randomGaussian((data.prev.x + cx) / 2, 3);
  const my = p5.prototype.randomGaussian((data.prev.y + cy) / 2, 3);
  const branch = svg.select('.shapes').insert('path', 'g')
    .classed('branch', true)
    .attr('d', d => `M${data.prev.x},${data.prev.y} Q${mx},${my} ${cx},${cy}`)
    .attr('fill', 'none');
  data.branchLength = branch.node().getTotalLength();
    // .attr('opacity', 0);

  // if it's a leaf, then just return the branch
  if (!petalsData[0].pathStroke) return {branch};

  const flower = svg.select('.shapes').append('g')
    .attr('transform', `translate(${[cx, cy]})`);

  flower.selectAll('.petal')
    .data(petalsData).enter().append('path')
    .classed('petal', true)
    .attr('d', d => {
      return _.map(d.pathStroke, p => {
        return `${p[0]} ${_.slice(p, 1).join(' ')}`;
      }).join(' ');
    }).attr('transform', (d) => `rotate(${d.rotate})scale(0)`)
    .attr('fill', '#fff')
    .attr('opacity', 1);

  return {branch, flower};
}


function animatePetals(branch, flower, ctx, data, petalsData) {
  let prevte = 0;
  const timer = d3.timer(elapsed => {
    let te = Math.min(elapsed, duration) / duration;

    if (flower) {
      flower.selectAll('.petal').attr('transform', (d) => `rotate(${d.rotate})scale(${te})`);
    }

    // draw petals if neutral or positive
    if (data.sentiment >= 0) {
      drawCanvasPetals(ctx, data, petalsData, 'path', te, 0.5);
    }

    // then draw branch
    const len1 = data.branchLength * prevte;
    const len2 = data.branchLength * te;
    _.times(Math.ceil(len2 - len1), i => {
      const {x, y} = branch.node().getPointAtLength(len1 + i);
      ctx.beginPath();
      ctx.arc(x, y, 3 / data.level, 0, 2 * Math.PI, 0);
      ctx.fillStyle = `rgba(0, 0, 0, 0.75)`;
      ctx.fill();
    })
    prevte = te;

    if (elapsed >= duration) {
      if (data.sentiment < 0) {
        drawCanvasPetals(ctx, data, petalsData, 'path', 1, 1);
      }
      timer.stop();
    };
  });

}

function drawCanvasPetals(ctx, data, petalsData, petalType, te, opacity) {
  let {cx, cy} = data;
  _.each(petalsData, (petal, i) => {
    ctx.beginPath();
    ctx.fillStyle = `rgba(0, 0, 0, ${opacity})`;
    _.each(petal[petalType], p => {
      const points = _.chain(p).slice(1)
        .map(point => {
          const [px, py] = point;
          const angle = (petal.rotate / 180) * Math.PI;
          const {x, y} = RotateVector({x: te * px, y: te * py}, angle)
          return [x + cx, y + cy];
        }).flatten().value();
      if (p[0] === 'M') {
        ctx.moveTo(points[0], points[1]);
      } else if (p[0] === 'C') {
        ctx.bezierCurveTo(points[0], points[1], points[2], points[3], points[4], points[5]);
      }
    });
    ctx.fill();
  });
}

export default {drawFlower};



// WEBPACK FOOTER //
// ./src/components/Flower.js